module.exports = __webpack_public_path__ + "static/media/23_A.a7a44af1.png";